import {
  Box,
  Collapse,
  Alert,
  IconButton,
  Stack,
  AlertColor
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useAppSelector } from 'src/app/hooks';
import { useTopNotification } from 'src/hooks/useTopNotification';
import { ArrowForwardIos } from '@mui/icons-material';
import { useNavigate } from 'react-router';

const TopNotification = () => {
  const { message, open, severity, showCloseButton } = useAppSelector(
    (state) => state.storeAlert.topNotification
  );
  const { handleCloseNotification } = useTopNotification();

  const navigate = useNavigate();

  const getAlertColor = (severity: AlertColor) => {
    switch (severity) {
      case 'error':
        return '#EF4444';
      case 'info':
        return '#4EA2FC';
      case 'warning':
        return '#A4781D';
      default:
        return '#4EA2FC';
    }
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Collapse in={open}>
        <Alert
          severity={severity}
          variant="filled"
          sx={{ backgroundColor: getAlertColor(severity), borderRadius: 0 }}
          action={
            showCloseButton ? (
              <IconButton
                aria-label="close"
                color="inherit"
                size="small"
                onClick={() => {
                  handleCloseNotification();
                }}
              >
                <CloseIcon fontSize="inherit" />
              </IconButton>
            ) : null
          }
        >
          <Stack direction="row" alignItems="center" spacing={0.5}>
            <Stack>{message}</Stack>
            <Stack
              direction="row"
              alignItems="center"
              spacing={0.5}
              onClick={() => navigate('/settings?parent_tab=billing')}
              sx={{ cursor: 'pointer' }}
            >
              <u>Update Your Payment Now</u>
              <ArrowForwardIos sx={{ fontSize: '12px' }} />
            </Stack>
          </Stack>
        </Alert>
      </Collapse>
    </Box>
  );
};

export default TopNotification;
